module.exports = __webpack_public_path__ + "img/1 (133).5a1f082e.png";